import React, { useState, useEffect } from 'react';
import axios from 'axios';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import SearchIcon from '@mui/icons-material/Search';
import * as XLSX from 'xlsx';
import { fetchData, deleteData, activateData } from '../../../apiService';
import { useAuth } from '../../../AuthContext';
import { tokenIsExpired } from '../../../authUtils';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import { IconButton } from '@mui/material';
import InfoIcon from '@mui/icons-material/Info';
import { Link } from 'react-router-dom'; // Import Link from react-router-dom
import Button from '@mui/material/Button';
import RefreshIcon from '@mui/icons-material/Refresh';
import FeedIcon from '@mui/icons-material/Feed';
import Select from 'react-select'; // Import react-select
import CopyrightIcon from '@mui/icons-material/Copyright';
import CircularProgress from '@mui/material/CircularProgress';
import ExcelJS from 'exceljs';
import { saveAs } from 'file-saver';

function DailySalesSummary() {
    const [dataBill, setDataBill] = useState([]);
    const [dataItem, setDataItem] = useState([]);
    const [searchQuery, setSearchQuery] = useState('');
    const [showSearchInput, setShowSearchInput] = useState(false);
    const tableRef = React.createRef();
    const [fromDate, setFromDate] = useState('');
    const [toDate, setToDate] = useState('');
    const [selectedOption, setSelectedOption] = useState('itemWise');
    const [customerOptions, setCustomerOptions] = useState([]);
    const [selectedCustomer, setSelectedCustomer] = useState(null);
    const [customerId, setCustomer] = useState('0');
    const { isAuthenticated, companyId, companyName, branchId, permissions, token, logout } = useAuth();
    const [totalcgst, setTotalcgst] = useState(0);
    const [totalsgst, setTotalsgst] = useState(0);
    const [totaligst, setTotaligst] = useState(0);
    const [totalnet, setTotalnet] = useState(0);
    const [totalamt, setTotalamt] = useState(0);
    const [totalpurchase, setTotalpurchase] = useState(0);
    const [totalqty, setTotalqty] = useState(0);
    const [isFocused, setIsFocused] = useState(false);

    useEffect(() => {
        if (isAuthenticated && tokenIsExpired(token)) {
            logout();
            return;
        }
        setFromDate(getFormattedStartDate());
        setToDate(getFormattedCurrentDate());
        fetchTableData();
        fetchCustomerData();
    }, [isAuthenticated, companyId, branchId, token, logout]);



    //const [totalbills, setTotalbills] = useState(0);

    const [totalbills, setTotalbills] = useState(0);
    const [totalMRP, settotalMRP] = useState(0);
    const [totalMRPONNET, settotalMRPONNET] = useState(0);
    const [totalDiscValue, settotalDiscValue] = useState(0);
    const [totalAddDiscValue, settotalAddDiscValue] = useState(0);
    const [totalCashDisc, settotalCashDisc] = useState(0);
    const [totalpurchasevalue, settotalpurchasevalue] = useState(0);
    const [totalcash, settotalcash] = useState(0);
    const [totaldigital, settotaldigital] = useState(0);
    const [totalother, settotalother] = useState(0);
    useEffect(() => {
        // Calculate totals
        let totalcgst = 0;
        let totalsgst = 0;
        let totaligst = 0;
        let totalnet = 0;
        let totalamt = 0;
        let totalpurchase = 0;
        let qty = 0;
        let billNumbers = new Set();
        let totalMRP = 0;
        let totalMRPONNET = 0;
        let totalDiscValue = 0;
        let totalAddDiscValue = 0;
        let totalCashDisc = 0;
        let totalpurchasevalue = 0;
        let totalcash = 0;
        let totaldigital = 0;
        //let totalother = 0;

        dataItem.forEach(item => {
            totalcgst += item.CGSTAmount;
            totalsgst += item.SGSTAmount;
            totaligst += item.IGSTAmount;
            totalnet += item.TaxableAmount;
            totalamt += item.TotalAmount;
            totalpurchase += item.PurchaseAmount;
            totalMRP += item.Rate;
            totalMRPONNET += item.Amount;
            totalDiscValue += item.DiscountAmount;
            totalAddDiscValue += item.AdditionalDiscountAmount;
            totalCashDisc += item.CashDiscount;
            totalpurchasevalue += item.PurchaseRate;
            totalcash += item.CashAmount;
            totaldigital += item.DigitalAmount;
            //totalother += item.UPIAmount;
            qty += item.Quantity;
            billNumbers.add(item.BillNumber); // Collect unique BillNumbers
        });

        setTotalcgst(totalcgst);
        setTotalsgst(totalsgst);
        setTotaligst(totaligst);
        setTotalnet(totalnet);
        setTotalamt(totalamt);
        setTotalqty(qty);
        setTotalpurchase(totalpurchase);
        settotalMRP(totalMRP);
        settotalMRPONNET(totalMRPONNET);
        settotalDiscValue(totalDiscValue);
        settotalAddDiscValue(totalAddDiscValue);
        settotalCashDisc(totalCashDisc);
        settotalpurchasevalue(totalpurchasevalue);
        settotalcash(totalcash);
        settotaldigital(totaldigital);
        // settotalother(totalother);
        const totalBills = billNumbers.size;
        setTotalbills(totalBills);
    }, [dataItem]);

    const fetchCustomerData = () => {
    };

    const getFormattedCurrentDate = () => {
        const currentDate = new Date();
        return currentDate.toISOString().split('T')[0];
    };

    const getFormattedStartDate = () => {
        const monthStartDate = new Date();
        monthStartDate.setDate(1);
        return monthStartDate.toISOString().split('T')[0];
    };

    const handleFromDateChange = (e) => {
        const selectedDate = e.target.value;
        setFromDate(selectedDate);
    };

    const handleToDateChange = (e) => {
        const selectedDate = e.target.value;
        setToDate(selectedDate);
    };

    const hasReadReportPermission = permissions.includes('Read Reports');

    const [loading, setLoading] = useState(false);

    const fetchTableData = async () => {
        if (hasReadReportPermission) {
            setDataItem([]);
            setLoading(true);
            try {
                const response = await fetchData('ReportApi', `/DailySalesSummary/${companyId}/${branchId}/${fromDate}/${toDate}`, token);
                if (response.responseCode === '1111') {
                    setDataItem(response.response_data);
                }
            } catch (error) {
                console.error('Error fetching Daily Sales Summary Details:', error);
            }
            finally {
                setLoading(false); // Hide loading screen
            }
        }
    };

    const handleSearch = (event) => {
        setSearchQuery(event.target.value);
    };

    const toggleSearchInput = () => {
        setShowSearchInput(!showSearchInput);
    };

    const filteredDataItem = dataItem.filter((item) =>
        Object.values(item).some((value) =>
            String(value).toLowerCase().includes(searchQuery.toLowerCase())
        )
    );

    const formatDate = (dateString) => {
        const options = { year: 'numeric', month: '2-digit', day: '2-digit' };
        return new Date(dateString).toLocaleDateString('en-GB', options);
    };

    const handleExportExcel = async () => {
        const workbook = new ExcelJS.Workbook();
        const worksheet = workbook.addWorksheet('DSS Payment Wise');
        worksheet.views = [
            { state: 'frozen', xSplit: 0, ySplit: 2 } // fixed header
        ];

        // Define headers (based on your TableCell JSX)
        const headerRowValues = [
            'Date', 'Bill No', 'Item No', 'Description', 'HSN Code', 'Quantity', 'MRP', 'MRP On Net',
            'Disc %', 'Disc value', 'Additional Disc%', 'Add Disc Value', 'Cash Disc', 'Balance',
            'GST %', 'CGST', 'SGST', 'IGST', 'Net Value', 'Gift Voucher', 'Net Value + Tax',
            'Purchase Rate', 'Total Purchase Value', 'Mode Of Pay', 'Cash', 'Digital',
            'DISC Type', 'GST No', 'Sales Man', 'Comments', 'GWP/PWP', 'Style', 'Brand'
        ];

        const rightAlignColumns = [
            'Quantity', 'MRP', 'MRP On Net', 'Disc %', 'Disc value', 'Additional Disc%',
            'Add Disc Value', 'Cash Disc', 'Balance', 'GST %', 'CGST', 'SGST', 'IGST',
            'Net Value', 'Gift Voucher', 'Net Value + Tax', 'Purchase Rate',
            'Total Purchase Value', 'Cash', 'Digital'
        ];

        // Title caption
        worksheet.mergeCells('A1:AN1');
        const captionCell = worksheet.getCell('A1');
        captionCell.value = `${companyName} - Daily Sales Summary Payment Wise From: ${formatDate(fromDate)} To: ${formatDate(toDate)}`;
        captionCell.alignment = { vertical: 'middle', horizontal: 'left', wrapText: true };
        captionCell.font = { bold: true, size: 14 };
        captionCell.alignment = { vertical: 'middle', horizontal: 'left' };

        const headerRow = worksheet.addRow(headerRowValues);
        const thinBorder = { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } };

        // Header styling
        headerRow.eachCell((cell) => {
            cell.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FFB6D7A8' } };
            cell.font = { bold: true };
            cell.alignment = { vertical: 'middle', horizontal: 'left', wrapText: true };
            cell.border = thinBorder;
        });

        // Add data rows
        filteredDataItem.forEach(rowData => {
            const rowValues = [
                formatDate(rowData.BillDate),
                rowData.BillNumber,
                parseFloat(rowData.Code),
                rowData.ItemName,
                rowData.HSNCode,
                rowData.Quantity,
                rowData.Rate,
                rowData.Amount,
                rowData.DiscountPercentage,
                rowData.DiscountAmount,
                rowData.AdditionalDiscountPercentage,
                rowData.AdditionalDiscountAmount,
                rowData.CashDiscount,
                rowData.TotalAmount,
                rowData.GSTRate,
                rowData.CGSTAmount,
                rowData.SGSTAmount,
                rowData.IGSTAmount,
                rowData.TaxableAmount,
                rowData.GiftVoucher || '', // optional field
                rowData.TotalAmount,
                rowData.PurchaseRate,
                rowData.PurchaseAmount,
                rowData.ModeOfPayment,
                rowData.CashAmount,
                rowData.DigitalAmount,
                //rowData.UPIAmount,
                //rowData.CardType,
                //rowData.CardNumber,
                //rowData.UPINumber,
                rowData.DiscType,
                rowData.GSTNumber,
                rowData.SalesManName,
                rowData.Remarks,
                rowData.Gwp,
                rowData.StyleName,
                rowData.BrandName
            ];

            const row = worksheet.addRow(rowValues);
            row.eachCell((cell, colNumber) => {
                const headerName = headerRowValues[colNumber - 1];
                if (rightAlignColumns.includes(headerName)) {
                    cell.alignment = { vertical: 'middle', horizontal: 'right' };
                    cell.numFmt = '#,##0.00';
                } else {
                    cell.alignment = { vertical: 'middle', horizontal: 'center' };
                }
                cell.border = thinBorder;
            });
        });

        const totalRowValues = [
            '', '', '', 'Total Bills', totalbills,
            totalqty, totalMRP, totalMRPONNET, '', totalDiscValue.toFixed(2),
            '', totalAddDiscValue.toFixed(2), totalCashDisc.toFixed(2), totalamt.toFixed(2),
            '', totalcgst.toFixed(2), totalsgst.toFixed(2), totaligst.toFixed(2), totalnet.toFixed(2),
            '', totalamt.toFixed(2), totalpurchasevalue.toFixed(2), totalpurchase.toFixed(2),
            '', totalcash.toFixed(2), totaldigital.toFixed(2),
            '', '', '', '', '', '', ''
        ];

        const totalRow = worksheet.addRow(totalRowValues);
        totalRow.font = { bold: true };
        totalRow.eachCell((cell, colNumber) => {
            const headerName = headerRowValues[colNumber - 1];
            if (rightAlignColumns.includes(headerName)) {
                cell.alignment = { vertical: 'middle', horizontal: 'right' };
                cell.numFmt = '#,##0.00';
            } else {
                cell.alignment = { vertical: 'middle', horizontal: 'center' };
            }
            cell.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FFE2EFDA' } };
            cell.border = thinBorder;
        });

        // Adjust column width
        worksheet.columns = headerRowValues.map(() => ({ width: 15 }));

        // Export to Excel
        const buffer = await workbook.xlsx.writeBuffer();
        saveAs(new Blob([buffer]), 'DSS_PaymentWise.xlsx');
    };

    const handlePrint = () => {

    };

    return (
        <div className="w-full  mx-auto" style={{ width: '100%', marginTop: '10px', margin: 0 }}>
            <div style={{ width: '100%', marginBottom: '2', display: 'flex', flexWrap: 'nowrap', alignItems: 'center' }}>
                <div className='w-full mb-2 flex' style={{ marginTop: '10px' }}>
                    <h6 className="block uppercase tracking-wide text-black productHead flex-grow linkcolor" style={{ fontFamily: 'Georgia, Cambria, "Times New Roman", Times, serif', color: 'black' }}>
                        Daily Sales Summary
                    </h6>

                    <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="gstNumber" style={{ color: 'black', fontSize: '13px', fontFamily: 'monospace', marginLeft: '-50px' }}>
                        Total net value : <span style={{ color: 'red', fontWeight: 'bold' }}>{totalnet.toFixed(2)}</span>
                    </label>
                </div>

                <div className='w-full mb-2 flex' style={{ marginTop: '10px', marginLeft: '55px' }}>

                    {loading && (
                        <div style={{
                            position: 'fixed',
                            top: 0,
                            left: 0,
                            width: '100%',
                            height: '100%',
                            backgroundColor: 'rgba(0, 0, 0, 0.5)',
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center',
                            zIndex: 9999
                        }}>
                            <div>
                                <CircularProgress style={{ color: 'white' }} />
                                <span style={{ color: 'white', marginTop: '10px', display: 'block' }}>Loading...</span>
                            </div>
                        </div>
                    )}



                    <div style={{ marginBottom: '10px', display: 'flex', alignItems: 'left', marginTop: '17px' }}>
                        <input
                            className="shadow text-gray-700 leading-tight"
                            type="text"
                            placeholder="Search..."
                            value={searchQuery}
                            onChange={handleSearch}
                            onFocus={() => setIsFocused(true)}
                            onBlur={() => setIsFocused(false)}
                            style={{
                                width: isFocused ? '270px' : '200px',
                                height: '30px',
                                border: '1px solid #ccc',
                                borderRadius: '15px',
                                padding: '0 20px',
                                transition: 'width 0.4s ease-in-out, border-color 0.3s ease-in-out',
                                outline: 'none',
                                borderColor: isFocused ? 'darkcyan' : '#ccc',
                                boxShadow: isFocused ? '0 4px 8px rgba(0, 0, 0, 0.2)' : 'none',
                            }}
                        />
                    </div>

                    <Button
                        style={{ color: "black", height: '36px', marginLeft: '10px', marginTop: '10px' }}
                        onClick={fetchTableData}
                        className="linkcolor"
                    >
                        <IconButton onClick={fetchTableData}>
                            {/* <RefreshIcon style={{ color: 'brown' }} /> */}
                        </IconButton>
                        <span style={{ color: 'brown', fontWeight: 'bolder', fontSize: '12px' }}>Refresh</span>
                    </Button>
                    <Button
                        style={{ color: "black", height: '36px', marginLeft: '10px', marginTop: '10px' }}
                        onClick={handleExportExcel}
                        className="linkcolor"
                    >
                        <IconButton onClick={handleExportExcel}>
                            {/* <FeedIcon style={{ color: 'darkgreen' }} /> */}
                        </IconButton>
                        <span style={{ color: 'darkgreen', fontWeight: 'bolder', fontSize: '12px' }}>Excel</span>
                    </Button>

                    <div className="watermark">
                        <CopyrightIcon /><b style={{ fontFamily: 'Script Bold Italic' }}>EFFTABS SOLUTIONS LLP</b>
                    </div>

                </div>

                <div style={{ marginRight: '2', maxWidth: '150px', marginLeft: '10px' }}>
                    <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="gstNumber" style={{ fontSize: '10px' }}>
                        From Date
                    </label>
                    <input
                        className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline h-8"
                        type="date" value={fromDate} onChange={handleFromDateChange}
                        style={{ fontSize: '12.5px', marginTop: '-10px', shadow: 'appearance-none', border: 'rounded', width: '100%', paddingY: '2', paddingX: '3', color: 'gray-700', leadingTight: true, focus: { color: 'gray-600', shadow: 'outline' } }}
                    />
                </div>
                <div style={{ marginRight: '2', maxWidth: '150px', marginLeft: '10px' }}>
                    <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="gstNumber" style={{ fontSize: '10px' }}>
                        To Date
                    </label>
                    <input
                        className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline h-8"
                        type="date" value={toDate} onChange={handleToDateChange}
                        style={{ fontSize: '12.5px', marginTop: '-10px', shadow: 'appearance-none', border: 'rounded', width: '100%', paddingY: '2', paddingX: '3', color: 'gray-700', leadingTight: true, focus: { color: 'gray-600', shadow: 'outline' } }}
                    />
                </div>
            </div>

            <div className='w-full mb-5 flex' style={{ maxHeight: '550px', overflowY: 'auto', marginTop: '7px' }}>
                <TableContainer component={Paper}>
                    <Table stickyHeader>
                        <TableHead sx={{ backgroundColor: '#08396B', Width: '2500px' }}>
                            <TableRow sx={{ whiteSpace: 'nowrap' }}>
                                <TableCell sx={{ backgroundColor: '#27445D', borderBottom: '1px solid #F5F5F5', borderRight: '1px solid grey', fontWeight: 'bolder', fontSize: '10px', padding: '3px', color: 'whitesmoke', textTransform: 'uppercase' }}>Date</TableCell>
                                <TableCell sx={{ backgroundColor: '#27445D', borderBottom: '1px solid #F5F5F5', borderRight: '1px solid grey', fontWeight: 'bolder', fontSize: '10px', padding: '3px', color: 'whitesmoke', textTransform: 'uppercase' }}>Bill No</TableCell>
                                <TableCell sx={{ backgroundColor: '#27445D', borderBottom: '1px solid #F5F5F5', borderRight: '1px solid grey', fontWeight: 'bolder', fontSize: '10px', padding: '3px', color: 'whitesmoke', textTransform: 'uppercase', width: '100%' }}>Item No</TableCell>
                                <TableCell sx={{ backgroundColor: '#27445D', borderBottom: '1px solid #F5F5F5', borderRight: '1px solid grey', fontWeight: 'bolder', fontSize: '10px', padding: '3px', color: 'whitesmoke', width: '50%', textTransform: 'uppercase' }}>Description</TableCell>
                                <TableCell sx={{ backgroundColor: '#27445D', borderBottom: '1px solid #F5F5F5', borderRight: '1px solid grey', fontWeight: 'bolder', fontSize: '10px', padding: '3px', color: 'whitesmoke', textTransform: 'uppercase' }}>HSN Code</TableCell>
                                <TableCell sx={{ backgroundColor: '#27445D', borderBottom: '1px solid #F5F5F5', borderRight: '1px solid grey', fontWeight: 'bolder', fontSize: '10px', padding: '3px', color: 'whitesmoke', textTransform: 'uppercase' }}>Quantity</TableCell>
                                <TableCell sx={{ backgroundColor: '#27445D', borderBottom: '1px solid #F5F5F5', borderRight: '1px solid grey', fontWeight: 'bolder', fontSize: '10px', padding: '3px', color: 'whitesmoke', textTransform: 'uppercase' }}>MRP</TableCell>
                                <TableCell sx={{ backgroundColor: '#27445D', borderBottom: '1px solid #F5F5F5', borderRight: '1px solid grey', fontWeight: 'bolder', fontSize: '10px', padding: '3px', color: 'whitesmoke', textTransform: 'uppercase' }}>MRP On Net</TableCell>
                                <TableCell sx={{ backgroundColor: '#27445D', borderBottom: '1px solid #F5F5F5', borderRight: '1px solid grey', fontWeight: 'bolder', fontSize: '10px', padding: '3px', color: 'whitesmoke', textTransform: 'uppercase' }}>Disc %</TableCell>
                                <TableCell sx={{ backgroundColor: '#27445D', borderBottom: '1px solid #F5F5F5', borderRight: '1px solid grey', fontWeight: 'bolder', fontSize: '10px', padding: '3px', color: 'whitesmoke', textTransform: 'uppercase' }}>Disc value</TableCell>
                                <TableCell sx={{ backgroundColor: '#27445D', borderBottom: '1px solid #F5F5F5', borderRight: '1px solid grey', fontWeight: 'bolder', fontSize: '10px', padding: '3px', color: 'whitesmoke', textTransform: 'uppercase' }}>Additional Disc%</TableCell>
                                <TableCell sx={{ backgroundColor: '#27445D', borderBottom: '1px solid #F5F5F5', borderRight: '1px solid grey', fontWeight: 'bolder', fontSize: '10px', padding: '3px', color: 'whitesmoke', textTransform: 'uppercase' }}>Add Disc Value</TableCell>
                                <TableCell sx={{ backgroundColor: '#27445D', borderBottom: '1px solid #F5F5F5', borderRight: '1px solid grey', fontWeight: 'bolder', fontSize: '10px', padding: '3px', color: 'whitesmoke', textTransform: 'uppercase' }}>Cash Disc</TableCell>
                                <TableCell sx={{ backgroundColor: '#27445D', borderBottom: '1px solid #F5F5F5', borderRight: '1px solid grey', fontWeight: 'bolder', fontSize: '10px', padding: '3px', color: 'whitesmoke', textTransform: 'uppercase' }}>Balance</TableCell>
                                <TableCell sx={{ backgroundColor: '#27445D', borderBottom: '1px solid #F5F5F5', borderRight: '1px solid grey', fontWeight: 'bolder', fontSize: '10px', padding: '3px', color: 'whitesmoke', textTransform: 'uppercase' }}>GST %</TableCell>
                                <TableCell sx={{ backgroundColor: '#27445D', borderBottom: '1px solid #F5F5F5', borderRight: '1px solid grey', fontWeight: 'bolder', fontSize: '10px', padding: '3px', color: 'whitesmoke', textTransform: 'uppercase' }}>CGST </TableCell>
                                <TableCell sx={{ backgroundColor: '#27445D', borderBottom: '1px solid #F5F5F5', borderRight: '1px solid grey', fontWeight: 'bolder', fontSize: '10px', padding: '3px', color: 'whitesmoke', textTransform: 'uppercase' }}>SGST </TableCell>
                                <TableCell sx={{ backgroundColor: '#27445D', borderBottom: '1px solid #F5F5F5', borderRight: '1px solid grey', fontWeight: 'bolder', fontSize: '10px', padding: '3px', color: 'whitesmoke', textTransform: 'uppercase' }}>IGST </TableCell>
                                <TableCell sx={{ backgroundColor: '#27445D', borderBottom: '1px solid #F5F5F5', borderRight: '1px solid grey', fontWeight: 'bolder', fontSize: '10px', padding: '3px', color: 'whitesmoke', textTransform: 'uppercase' }}>Net Value</TableCell>
                                <TableCell sx={{ backgroundColor: '#27445D', borderBottom: '1px solid #F5F5F5', borderRight: '1px solid grey', fontWeight: 'bolder', fontSize: '10px', padding: '3px', color: 'whitesmoke', textTransform: 'uppercase' }}>Gift Voucher</TableCell>
                                <TableCell sx={{ backgroundColor: '#27445D', borderBottom: '1px solid #F5F5F5', borderRight: '1px solid grey', fontWeight: 'bolder', fontSize: '10px', padding: '3px', color: 'whitesmoke', textTransform: 'uppercase' }}>Net Value + Tax</TableCell>
                                <TableCell sx={{ backgroundColor: '#27445D', borderBottom: '1px solid #F5F5F5', borderRight: '1px solid grey', fontWeight: 'bolder', fontSize: '10px', padding: '3px', color: 'whitesmoke', textTransform: 'uppercase' }}>Purchase Rate</TableCell>
                                <TableCell sx={{ backgroundColor: '#27445D', borderBottom: '1px solid #F5F5F5', borderRight: '1px solid grey', fontWeight: 'bolder', fontSize: '10px', padding: '3px', color: 'whitesmoke', textTransform: 'uppercase' }}>Total Purchase Value</TableCell>
                                <TableCell sx={{ backgroundColor: '#27445D', borderBottom: '1px solid #F5F5F5', borderRight: '1px solid grey', fontWeight: 'bolder', fontSize: '10px', padding: '3px', color: 'whitesmoke', textTransform: 'uppercase' }}>Mode Of Pay</TableCell>
                                <TableCell sx={{ backgroundColor: '#27445D', borderBottom: '1px solid #F5F5F5', borderRight: '1px solid grey', fontWeight: 'bolder', fontSize: '10px', padding: '3px', color: 'whitesmoke', textTransform: 'uppercase' }}>Cash </TableCell>
                                <TableCell sx={{ backgroundColor: '#27445D', borderBottom: '1px solid #F5F5F5', borderRight: '1px solid grey', fontWeight: 'bolder', fontSize: '10px', padding: '3px', color: 'whitesmoke', textTransform: 'uppercase' }}>Digital </TableCell>
                                <TableCell sx={{ backgroundColor: '#27445D', borderBottom: '1px solid #F5F5F5', borderRight: '1px solid grey', fontWeight: 'bolder', fontSize: '10px', padding: '3px', color: 'whitesmoke', textTransform: 'uppercase' }}>GST No</TableCell>
                                <TableCell sx={{ backgroundColor: '#27445D', borderBottom: '1px solid #F5F5F5', borderRight: '1px solid grey', fontWeight: 'bolder', fontSize: '10px', padding: '3px', color: 'whitesmoke', textTransform: 'uppercase' }}>Sales Man</TableCell>
                                <TableCell sx={{ backgroundColor: '#27445D', borderBottom: '1px solid #F5F5F5', borderRight: '1px solid grey', fontWeight: 'bolder', fontSize: '10px', padding: '3px', color: 'whitesmoke', textTransform: 'uppercase' }}>Comments</TableCell>
                                <TableCell sx={{ backgroundColor: '#27445D', borderBottom: '1px solid #F5F5F5', borderRight: '1px solid grey', fontWeight: 'bolder', fontSize: '10px', padding: '3px', color: 'whitesmoke', textTransform: 'uppercase' }}>GWP/PWP</TableCell>
                                <TableCell sx={{ backgroundColor: '#27445D', borderBottom: '1px solid #F5F5F5', borderRight: '1px solid grey', fontWeight: 'bolder', fontSize: '10px', padding: '3px', color: 'whitesmoke', textTransform: 'uppercase' }}>Style</TableCell>
                                <TableCell sx={{ backgroundColor: '#27445D', borderBottom: '1px solid #F5F5F5', borderRight: '1px solid grey', fontWeight: 'bolder', fontSize: '10px', padding: '3px', color: 'whitesmoke', textTransform: 'uppercase' }}>Brand</TableCell>
                            </TableRow>
                        </TableHead>

                        <TableBody sx={{ backgroundColor: 'whitesmoke' }}>
                            {filteredDataItem.map((data, index) => {
                                // Check if this is the first occurrence of the BillNumber
                                const isFirstOfBill =
                                    index === 0 || data.BillNumber !== filteredDataItem[index - 1].BillNumber;

                                return (
                                    <TableRow
                                        key={data.id}
                                        className={data.routeName === 'Total' ? 'highlighted-row' : ''}
                                        sx={{
                                            padding: '7px',
                                            backgroundColor: data.routeName === 'Total' ? 'teal' : 'transparent',
                                        }}
                                    >
                                        <TableCell sx={{ borderBottom: '1px solid black', borderRight: '1px solid grey', color: 'black', fontWeight: 'bolder', padding: '3px', textAlign: 'left', fontSize: '10.5px' }}>
                                            {formatDate(data.BillDate)} {data.BillTime}
                                        </TableCell>
                                        <TableCell sx={{ borderBottom: '1px solid black', borderRight: '1px solid grey', color: 'black', fontWeight: 'bolder', padding: '3px', textAlign: 'left', fontSize: '10.5px' }}>
                                            {data.BillNumber}
                                        </TableCell>
                                        <TableCell sx={{ borderBottom: '1px solid black', borderRight: '1px solid grey', color: 'black', fontWeight: 'bolder', padding: '3px', textAlign: 'left', fontSize: '10.5px' }}>
                                            {data.Code}
                                        </TableCell>
                                        <TableCell sx={{ borderBottom: '1px solid black', borderRight: '1px solid grey', color: 'black', fontWeight: 'bolder', padding: '3px', textAlign: 'left', fontSize: '10.5px', width: '50%' }}>
                                            {data.ItemName}
                                        </TableCell>
                                        <TableCell sx={{ borderBottom: '1px solid black', borderRight: '1px solid grey', color: 'black', fontWeight: 'bolder', padding: '3px', textAlign: 'left', fontSize: '10.5px' }}>
                                            {data.HSNCode}
                                        </TableCell>
                                        <TableCell sx={{ borderBottom: '1px solid black', borderRight: '1px solid grey', color: 'black', fontWeight: 'bolder', padding: '3px', textAlign: 'center', fontSize: '10.5px' }}>
                                            {data.Quantity}
                                        </TableCell>
                                        <TableCell sx={{ borderBottom: '1px solid black', borderRight: '1px solid grey', color: 'black', fontWeight: 'bolder', padding: '3px', textAlign: 'right', fontSize: '10.5px' }}>
                                            {data.Rate ? data.Rate.toFixed(2) : '0.00'}
                                        </TableCell>
                                        <TableCell sx={{ borderBottom: '1px solid black', borderRight: '1px solid grey', color: 'black', fontWeight: 'bolder', padding: '3px', textAlign: 'right', fontSize: '10.5px' }}>
                                            {data.Amount ? data.Amount.toFixed(2) : '0.00'}
                                        </TableCell>
                                        <TableCell sx={{ borderBottom: '1px solid black', borderRight: '1px solid grey', color: 'black', fontWeight: 'bolder', padding: '3px', textAlign: 'right', fontSize: '10.5px' }}>
                                            {data.DiscountPercentage}
                                        </TableCell>
                                        <TableCell sx={{ borderBottom: '1px solid black', borderRight: '1px solid grey', color: 'black', fontWeight: 'bolder', padding: '3px', textAlign: 'right', fontSize: '10.5px' }}>
                                            {data.DiscountAmount ? data.DiscountAmount.toFixed(2) : '0.00'}
                                        </TableCell>
                                        <TableCell sx={{ borderBottom: '1px solid black', borderRight: '1px solid grey', color: 'black', fontWeight: 'bolder', padding: '3px', textAlign: 'right', fontSize: '10.5px' }}>
                                            {data.AdditionalDiscountPercentage}
                                        </TableCell>
                                        <TableCell sx={{ borderBottom: '1px solid black', borderRight: '1px solid grey', color: 'black', fontWeight: 'bolder', padding: '3px', textAlign: 'right', fontSize: '10.5px' }}>
                                            {data.AdditionalDiscountAmount ? data.AdditionalDiscountAmount.toFixed(2) : '0.00'}
                                        </TableCell>
                                        <TableCell sx={{ borderBottom: '1px solid black', borderRight: '1px solid grey', color: 'black', fontWeight: 'bolder', padding: '3px', textAlign: 'right', fontSize: '10.5px' }}>
                                            {data.CashDiscount ? data.CashDiscount.toFixed(2) : '0.00'}
                                        </TableCell>
                                        <TableCell sx={{ borderBottom: '1px solid black', borderRight: '1px solid grey', color: 'black', fontWeight: 'bolder', padding: '3px', textAlign: 'right', fontSize: '10.5px' }}>
                                            {data.TotalAmount ? data.TotalAmount.toFixed(2) : '0.00'}
                                        </TableCell>
                                        <TableCell sx={{ borderBottom: '1px solid black', borderRight: '1px solid grey', color: 'black', fontWeight: 'bolder', padding: '3px', textAlign: 'right', fontSize: '10.5px' }}>
                                            {data.GSTRate}
                                        </TableCell>
                                        <TableCell sx={{ borderBottom: '1px solid black', borderRight: '1px solid grey', color: 'black', fontWeight: 'bolder', padding: '3px', textAlign: 'right', fontSize: '10.5px' }}>
                                            {data.CGSTAmount ? data.CGSTAmount.toFixed(2) : '0.00'}
                                        </TableCell>
                                        <TableCell sx={{ borderBottom: '1px solid black', borderRight: '1px solid grey', color: 'black', fontWeight: 'bolder', padding: '3px', textAlign: 'right', fontSize: '10.5px' }}>
                                            {data.SGSTAmount ? data.SGSTAmount.toFixed(2) : '0.00'}
                                        </TableCell>
                                        <TableCell sx={{ borderBottom: '1px solid black', borderRight: '1px solid grey', color: 'black', fontWeight: 'bolder', padding: '3px', textAlign: 'right', fontSize: '10.5px' }}>
                                            {data.IGSTAmount ? data.IGSTAmount.toFixed(2) : '0.00'}
                                        </TableCell>
                                        <TableCell sx={{ borderBottom: '1px solid black', borderRight: '1px solid grey', color: 'black', fontWeight: 'bolder', padding: '3px', textAlign: 'right', fontSize: '10.5px' }}>
                                            {data.TaxableAmount ? data.TaxableAmount.toFixed(2) : '0.00'}
                                        </TableCell>
                                        <TableCell sx={{ borderBottom: '1px solid black', borderRight: '1px solid grey', color: 'black', fontWeight: 'bolder', padding: '3px', textAlign: 'left', fontSize: '10.5px' }}></TableCell>
                                        <TableCell sx={{ borderBottom: '1px solid black', borderRight: '1px solid grey', color: 'black', fontWeight: 'bolder', padding: '3px', textAlign: 'right', fontSize: '10.5px' }}>
                                            {data.TotalAmount ? data.TotalAmount.toFixed(2) : '0.00'}
                                        </TableCell>
                                        <TableCell sx={{ borderBottom: '1px solid black', borderRight: '1px solid grey', color: 'black', fontWeight: 'bolder', padding: '3px', textAlign: 'right', fontSize: '10.5px' }}>
                                            {data.PurchaseRate ? data.PurchaseRate.toFixed(2) : '0.00'}
                                        </TableCell>
                                        <TableCell sx={{ borderBottom: '1px solid black', borderRight: '1px solid grey', color: 'black', fontWeight: 'bolder', padding: '3px', textAlign: 'right', fontSize: '10.5px' }}>
                                            {data.PurchaseAmount ? data.PurchaseAmount.toFixed(2) : '0.00'}
                                        </TableCell>
                                        <TableCell sx={{ borderBottom: '1px solid black', borderRight: '1px solid grey', color: 'black', fontWeight: 'bolder', padding: '3px', textAlign: 'left', fontSize: '10.5px' }}>
                                            {data.ModeOfPayment}
                                        </TableCell>

                                        {/* ✅ Show these only once per BillNumber */}
                                        <TableCell
                                            sx={{
                                                borderBottom: '1px solid black',
                                                borderRight: '1px solid grey',
                                                color: 'black',
                                                fontWeight: 'bolder',
                                                padding: '3px',
                                                textAlign: 'right',
                                                fontSize: '10.5px',
                                            }}
                                        >
                                            {isFirstOfBill ? (data.CashAmount ? data.CashAmount.toFixed(2) : '0.00') : '-'}
                                        </TableCell>
                                        <TableCell
                                            sx={{
                                                borderBottom: '1px solid black',
                                                borderRight: '1px solid grey',
                                                color: 'black',
                                                fontWeight: 'bolder',
                                                padding: '3px',
                                                textAlign: 'right',
                                                fontSize: '10.5px',
                                            }}
                                        >
                                            {isFirstOfBill ? (data.DigitalAmount ? data.DigitalAmount.toFixed(2) : '0.00') : '-'}
                                        </TableCell>

                                        <TableCell sx={{ borderBottom: '1px solid black', borderRight: '1px solid grey', color: 'black', fontWeight: 'bolder', padding: '3px', textAlign: 'left', fontSize: '10.5px' }}>
                                            {data.GSTNumber}
                                        </TableCell>
                                        <TableCell sx={{ borderBottom: '1px solid black', borderRight: '1px solid grey', color: 'black', fontWeight: 'bolder', padding: '3px', textAlign: 'left', fontSize: '10.5px' }}>
                                            {data.SalesManName}
                                        </TableCell>
                                        <TableCell sx={{ borderBottom: '1px solid black', borderRight: '1px solid grey', color: 'black', fontWeight: 'bolder', padding: '3px', textAlign: 'left', fontSize: '10.5px' }}>
                                            {data.Remarks}
                                        </TableCell>
                                        <TableCell sx={{ borderBottom: '1px solid black', borderRight: '1px solid grey', color: 'black', fontWeight: 'bolder', padding: '3px', textAlign: 'left', fontSize: '10.5px' }}>
                                            {data.Gwp}
                                        </TableCell>
                                        <TableCell sx={{ borderBottom: '1px solid black', borderRight: '1px solid grey', color: 'black', fontWeight: 'bolder', padding: '3px', textAlign: 'left', fontSize: '10.5px' }}>
                                            {data.StyleName}
                                        </TableCell>
                                        <TableCell sx={{ borderBottom: '1px solid black', borderRight: '1px solid grey', color: 'black', fontWeight: 'bolder', padding: '3px', textAlign: 'left', fontSize: '10.5px' }}>
                                            {data.BrandName}
                                        </TableCell>
                                    </TableRow>
                                );
                            })}

                            <TableRow
                                className={'highlighted-row'}
                                sx={{
                                    padding: '7px',
                                    height: '30px',
                                    background: 'linear-gradient(to right, #063e68ff, #063e68ff)',
                                }}
                            >
                                <TableCell colSpan={3} />
                                <TableCell sx={{ borderBottom: '1px solid #F5F5F5', color: 'whitesmoke', fontWeight: 'bolder', padding: '5px', textAlign: 'left', fontSize: '9px', textTransform: 'uppercase' }}>Total Bills</TableCell>
                                <TableCell sx={{ borderBottom: '1px solid #F5F5F5', color: 'whitesmoke', fontWeight: 'bolder', padding: '5px', textAlign: 'right', fontSize: '12px' }}>{totalbills}</TableCell>
                                <TableCell sx={{ borderBottom: '1px solid #F5F5F5', color: 'whitesmoke', fontWeight: 'bolder', padding: '5px', textAlign: 'center', fontSize: '12px' }}>{totalqty}</TableCell>
                                <TableCell sx={{ borderBottom: '1px solid #F5F5F5', color: 'whitesmoke', fontWeight: 'bolder', padding: '5px', textAlign: 'right', fontSize: '12px' }}>{totalMRP}</TableCell>
                                <TableCell sx={{ borderBottom: '1px solid #F5F5F5', color: 'whitesmoke', fontWeight: 'bolder', padding: '5px', textAlign: 'right', fontSize: '12px' }}>{totalMRPONNET}</TableCell>
                                <TableCell sx={{ borderBottom: '1px solid #F5F5F5', color: 'whitesmoke', fontWeight: 'bolder', padding: '5px', textAlign: 'right', fontSize: '12px' }}></TableCell>
                                <TableCell sx={{ borderBottom: '1px solid #F5F5F5', color: 'whitesmoke', fontWeight: 'bolder', padding: '5px', textAlign: 'right', fontSize: '12px' }}>{totalDiscValue.toFixed(2)}</TableCell>
                                <TableCell sx={{ borderBottom: '1px solid #F5F5F5', color: 'whitesmoke', fontWeight: 'bolder', padding: '5px', textAlign: 'right', fontSize: '12px' }}></TableCell>
                                <TableCell sx={{ borderBottom: '1px solid #F5F5F5', color: 'whitesmoke', fontWeight: 'bolder', padding: '5px', textAlign: 'right', fontSize: '12px' }}>{totalAddDiscValue.toFixed(2)}</TableCell>
                                <TableCell sx={{ borderBottom: '1px solid #F5F5F5', color: 'whitesmoke', fontWeight: 'bolder', padding: '5px', textAlign: 'right', fontSize: '12px' }}>{totalCashDisc.toFixed(2)}</TableCell>
                                <TableCell sx={{ borderBottom: '1px solid #F5F5F5', color: 'whitesmoke', fontWeight: 'bolder', padding: '5px', textAlign: 'right', fontSize: '12px' }}>{totalamt.toFixed(2)}</TableCell>
                                <TableCell sx={{ borderBottom: '1px solid #F5F5F5', color: 'whitesmoke', fontWeight: 'bolder', padding: '5px', textAlign: 'right', fontSize: '12px' }}></TableCell>
                                <TableCell sx={{ borderBottom: '1px solid #F5F5F5', color: 'whitesmoke', fontWeight: 'bolder', padding: '5px', textAlign: 'right', fontSize: '12px' }}>{totalcgst.toFixed(2)}</TableCell>
                                <TableCell sx={{ borderBottom: '1px solid #F5F5F5', color: 'whitesmoke', fontWeight: 'bolder', padding: '5px', textAlign: 'right', fontSize: '12px' }}>{totalsgst.toFixed(2)}</TableCell>
                                <TableCell sx={{ borderBottom: '1px solid #F5F5F5', color: 'whitesmoke', fontWeight: 'bolder', padding: '5px', textAlign: 'right', fontSize: '12px' }}>{totaligst.toFixed(2)}</TableCell>
                                <TableCell sx={{ borderBottom: '1px solid #F5F5F5', color: 'whitesmoke', fontWeight: 'bolder', padding: '5px', textAlign: 'right', fontSize: '12px' }}>{totalnet.toFixed(2)}</TableCell>
                                <TableCell sx={{ borderBottom: '1px solid #F5F5F5', color: 'whitesmoke', fontWeight: 'bolder', padding: '5px', textAlign: 'right', fontSize: '12px' }}></TableCell>
                                <TableCell sx={{ borderBottom: '1px solid #F5F5F5', color: 'whitesmoke', fontWeight: 'bolder', padding: '5px', textAlign: 'right', fontSize: '12px' }}>{totalamt.toFixed(2)}</TableCell>
                                <TableCell sx={{ borderBottom: '1px solid #F5F5F5', color: 'whitesmoke', fontWeight: 'bolder', padding: '5px', textAlign: 'right', fontSize: '12px' }}>{totalpurchasevalue.toFixed(2)}</TableCell>
                                <TableCell sx={{ borderBottom: '1px solid #F5F5F5', color: 'whitesmoke', fontWeight: 'bolder', padding: '5px', textAlign: 'right', fontSize: '12px' }}>{totalpurchase.toFixed(2)}</TableCell>
                                <TableCell sx={{ borderBottom: '1px solid #F5F5F5', color: 'whitesmoke', fontWeight: 'bolder', padding: '5px', textAlign: 'right', fontSize: '12px' }}></TableCell>
                                <TableCell sx={{ borderBottom: '1px solid #F5F5F5', color: 'whitesmoke', fontWeight: 'bolder', padding: '5px', textAlign: 'right', fontSize: '12px' }}>{totalcash.toFixed(2)}</TableCell>
                                <TableCell sx={{ borderBottom: '1px solid #F5F5F5', color: 'whitesmoke', fontWeight: 'bolder', padding: '5px', textAlign: 'right', fontSize: '12px' }}>{totaldigital.toFixed(2)}</TableCell>
                                {/* <TableCell sx={{ borderBottom: '1px solid #F5F5F5', color: 'whitesmoke', fontWeight: 'bolder', padding: '5px', textAlign: 'right', fontSize: '12px' }}>{totalother.toFixed(2)}</TableCell> */}
                                <TableCell sx={{ borderBottom: '1px solid #F5F5F5', color: 'whitesmoke', fontWeight: 'bolder', padding: '5px', textAlign: 'right', fontSize: '12px' }}></TableCell>
                                <TableCell sx={{ borderBottom: '1px solid #F5F5F5', color: 'whitesmoke', fontWeight: 'bolder', padding: '5px', textAlign: 'right', fontSize: '12px' }}></TableCell>
                                <TableCell sx={{ borderBottom: '1px solid #F5F5F5', color: 'whitesmoke', fontWeight: 'bolder', padding: '5px', textAlign: 'right', fontSize: '12px' }}></TableCell>
                                <TableCell colSpan={20} />
                            </TableRow>

                        </TableBody>
                    </Table>
                </TableContainer>
            </div>
        </div >
    );
}
export default DailySalesSummary;
